import { render, staticRenderFns } from "./ComposeMail.vue?vue&type=template&id=4532aa21&scoped=true"
import script from "./ComposeMail.vue?vue&type=script&lang=js"
export * from "./ComposeMail.vue?vue&type=script&lang=js"
import style0 from "./ComposeMail.vue?vue&type=style&index=0&id=4532aa21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532aa21",
  null
  
)

export default component.exports